/**
 * Issue #2992 — shared mapping from a SpeechRecognition error code to a
 * user-facing message, used by every voice-input affordance (NewGame composer,
 * ChatPanel composer, SoulInterviewTurnCard, TvSteeringSurface). A denied or
 * missing microphone used to fail silently on each of these surfaces.
 *
 * Returns null for benign outcomes (the user cancelled, or simply said
 * nothing) so those stay quiet; everything else must be surfaced instead of
 * failing silently.
 *
 * @param typingFallback surface-specific typing guidance, e.g.
 *   "type your idea instead" / "type your answer instead".
 */
export function voiceInputErrorMessage(
  error: string | undefined,
  typingFallback: string,
): string | null {
  switch (error) {
    case 'not-allowed':
    case 'service-not-allowed':
      return `Microphone access is blocked. Allow microphone access in your system settings, then try again — or ${typingFallback}.`;
    case 'audio-capture':
      return `No microphone was found. Connect a microphone and try again — or ${typingFallback}.`;
    case 'aborted':
    case 'no-speech':
      return null;
    default:
      return `Voice input failed. You can ${typingFallback}.`;
  }
}
